"use client";

import { Container } from "@mui/material";
import EmployeeTable from "../components/EmpleadosTable";

export default function EmpleadosPage() {
  return (

    <Container maxWidth="lg" sx={{}}>

      <EmployeeTable />

    </Container>
  );
}
